import * as React from "react";

const codePush = (settings) => (App) => App;

codePush.getUpdateMetaData = () => {
  return Promise.resolve(null);
};

codePush.checkForUpdate = () => {
  return false;
}

export default codePush;
